import VueRouter from 'vue-router'
import Login from "@/pages/Login";
import List from "@/pages/List"
const routes = [
    { path: '/', redirect: '/login' },
    { path: '/login', component: Login },
    { path: '/list', component: List }
]

// 3. 创建 router 实例，然后传 `routes` 配置
// 你还可以传别的配置参数, 不过先这么简单着吧。
const router = new VueRouter({
    routes // (缩写) 相当于 routes: routes
})
export default router;